import { useMutation, UseMutationResult } from "@tanstack/react-query";
import axiosInstance from "./axiosInstance";
import { enum_api_uri } from "../utils/enum";

interface ParamsRequest {
    category: string;
}
interface BodyRequest {
    vTitle: string;
    vPopSizeW: number;
    vPopSizeH: number;
    vPopX: number;
    vPopY: number;
    cViewYN: string;
    cTodayYN: string;
    cPvL: string;
    vContent: string;
}

type PostPopupRequest = ParamsRequest & BodyRequest;

interface PostPopupResponse {
    idx: number;
}

export const usePostConsolePopup = (): UseMutationResult<PostPopupResponse, Error, PostPopupRequest, unknown> => {
    // const queryClient = useQueryClient();

    return useMutation<PostPopupResponse, Error, PostPopupRequest>({
        mutationFn: async (data: PostPopupRequest) => {
            const url = enum_api_uri.post_console_popup.replace(":category", data.category);
            const response = await axiosInstance.post(url, {
                vTitle: data.vTitle,
                vPopSizeW: data.vPopSizeW,
                vPopSizeH: data.vPopSizeH,
                vPopX: data.vPopX,
                vPopY: data.vPopY,
                cViewYN: data.cViewYN,
                cTodayYN: data.cTodayYN,
                cPvL: data.cPvL,
                vContent: data.vContent,
            });
            return response.data.data;
        },
        onSuccess: data => {
            return data;
        },
    });
};
